interface FAQItem {
  question: string;
  answer: string;
}

interface FAQProps {
  items: FAQItem[];
}

export default function FAQ({ items }: FAQProps) {
  return (
    <section aria-label="常见问题">
      <div className="space-y-3">
        {items.map((item, index) => (
          <details
            key={index}
            className="group bg-background-50 rounded-lg border border-background-200 overflow-hidden"
          >
            <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
              <h4 className="font-heading text-sm md:text-base font-bold text-foreground-900 pr-4">
                {item.question}
              </h4>
              <div className="w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 group-open:bg-primary-100 flex-shrink-0 transition-colors">
                <i className="ri-add-line text-foreground-700 group-open:hidden text-sm"></i>
                <i className="ri-subtract-line text-primary-600 hidden group-open:block text-sm"></i>
              </div>
            </summary>
            <div className="px-5 pb-4">
              <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
            </div>
          </details>
        ))}
      </div>
    </section>
  );
}